<template>
  <section class="main-info">
    <div class="input">
      <label
        class="label"
        for="factory-name"
      >{{ $t('factory-name-title') }}</label>
      <input
        id="factory-name"
        :name="`${inputName}[name]`"
        :placeholder="$t('factory-name-placeholder')"
        :value="name"
        type="text"
        @input="$emit('nameChange', $event.target.value)"
      />
    </div>
    <div
      class="input main-info__files"
      style="margin-bottom: 47px;"
    >
      <div
        :style="`max-width: ${logoMaxWidth}`"
        style="width: 100%;"
      >
        <label class="label">
          {{ $t('logo-label') }} ({{ $t('min') }} 90x90 px)
        </label>
        <DropImages
          v-show="!logo"
          :crop="true"
          :logo="logo"
          :multiple="false"
          :name="`${inputName}[logo]`"
          :open-popup="showPopupAfterCrop"
          :remove-name="`${inputName}[remove_logo]`"
          @logoChange="onLogoChange"
        />
        <div
          v-if="logo"
          class="factory-create__logo-wrap"
        >
          <div class="factory-create__logo">
            <img
              :src="logo"
              alt="logo"
            />
          </div>
          <div
            class="factory-create__remove-logo text-caption-l"
            @click="$emit('logoChange', null)"
          >
            <i class="icon icon-trash icon_norm" />
            {{ $t('remove_logo') }}
          </div>
        </div>
      </div>

      <!--      <div-->
      <!--        v-if="showIconChat"-->
      <!--        class="ml-60"-->
      <!--      >-->
      <!--        <label class="label">-->
      <!--          {{ $t('logo-chat-label') }}-->
      <!--        </label>-->
      <!--        <DropImages-->
      <!--          v-show="!iconChat"-->
      <!--          :logo="iconChat"-->
      <!--          :multiple="false"-->
      <!--          :name="`${inputName}[logo_chat]`"-->
      <!--          :remove-name="`${inputName}[remove_logo_chat]`"-->
      <!--          :small="true"-->
      <!--          style="width: 90px;"-->
      <!--          @filesLoad="onIconChatLoad"-->
      <!--        />-->
      <!--        <div-->
      <!--          v-if="iconChat"-->
      <!--          class="factory-create__logo-wrap"-->
      <!--        >-->
      <!--          <div class="factory-create__logo">-->
      <!--            <img-->
      <!--              :src="iconChat"-->
      <!--              alt="logo"-->
      <!--            />-->
      <!--          </div>-->
      <!--          <div-->
      <!--            class="factory-create__remove-logo text-caption-l"-->
      <!--            @click="$emit('iconChatChange', null)"-->
      <!--          >-->
      <!--            <i class="icon icon-trash icon_norm" />-->
      <!--            {{ $t('remove_logo') }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="mb-30">
      <p
        class="text-body-l"
        style="margin-bottom: 5px;"
      >
        {{ $t('location-label') }}
      </p>
      <SelectFromApi
        :input-name="inputName"
        :value="valueLocation"
        @input="$emit('valueLocationChange', $event)"
      />
    </div>
    <div class="input">
      <label
        class="label"
        for="phone-name"
      >{{ $t('phone-name-title') }}</label>
      <InputPhone
        id-el="phone-name"
        :name-el="`${inputName}[phone]`"
        :value="phoneValue"
        @input="$emit('phoneValueChange', $event)"
        @inputValid="$emit('phoneValid', $event)"
      />
    </div>
  </section>
</template>

<script>
  import DropImages from '../../DropImages.vue'
  import SelectFromApi from '../../SelectFromApi.vue'
  import InputPhone from './InputPhone.vue'

  export default {
    name: 'MainInfo',
    components: { InputPhone, SelectFromApi, DropImages },
    props: {
      inputName: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      phoneValue: {
        type: String,
        default: '',
      },
      logo: {
        validator: v => typeof v === 'string' || v === null,
        required: true,
      },
      showIconChat: {
        type: Boolean,
        default: false,
      },
      iconChat: {
        validator: v => typeof v === 'string' || v === null,
        default: null,
      },
      valueLocation: {
        type: String,
        required: true,
      },
      valueCounty: {
        default: () => [],
        type: Array,
      },
      logoMaxWidth: {
        type: String,
        default: '404px',
      },
      showPopupAfterCrop: {
        type: String,
        default: '',
      },
    },
    methods: {
      onLogoLoad(logo) {
        if (!Array.isArray(logo)) return
        this.$emit('logoChange', window.URL.createObjectURL(logo[0]))
      },
      onLogoChange(dataUrl) {
        this.$emit('logoChange', dataUrl)
      },
      onIconChatLoad(iconChat) {
        if (!Array.isArray(iconChat)) return
        this.$emit('iconChatChange', window.URL.createObjectURL(iconChat[0]))
      },
      onHintsClick(hint, valueItem) {
        if (this[valueItem].find(value => value === hint)) return
        this.$emit(`${valueItem}Change`, [...this[valueItem], hint])
      },
    },
  }
</script>
